import axios from "axios";
import { getEntity } from "../utils/entities/getEntity";
const { REACT_APP_SICTM_URL } = process.env;

async function getLines(companyId: number) {
  const entity = getEntity()
  const res = await axios.get(
    `${REACT_APP_SICTM_URL}/lines?entityId=${entity.id}&companyId=${companyId}`
  );

  return res.data;
}

async function getLinesShort(l1: number, l2: number) {
  const res = await axios.get(
    `${REACT_APP_SICTM_URL}/lines/short?lin=${l1}&lin=${l2}&tt=true&act=true&sub=true&ope=true`
  );
  return res.data;
}

async function getNextStops(stopId: number) {
  try {
    const res = await axios.get(
      `${REACT_APP_SICTM_URL}/stops/id/${stopId}/next-departures?pag=1&res=25&ignoreLast=1`
    );
    return res.data.nextDeparturesInfo;
  } catch (err) { }
}

async function getLineById(id: number) {
  const res = await axios.get(`${REACT_APP_SICTM_URL}/lines/id/${id}`);
  return res.data;
}

async function getStopById(id: number) {
  const res = await axios.get(`${REACT_APP_SICTM_URL}/stops/id/${id}`);
  return res.data;
}

async function getSublines() {
  const entity = getEntity()

  const res = await axios.get(`${REACT_APP_SICTM_URL}/sublines/${entity.name}`);
  return res.data;
}

async function getNotifications() {
  const entity = getEntity();

  const res = await axios.get(
    `${REACT_APP_SICTM_URL}/notices/${entity.name}?lng=es-ES`
  );
  return res.data;
}

async function getNotificationById(noticeId: number) {
  const res = await axios.get(`${REACT_APP_SICTM_URL}/notices/id/${noticeId}`);
  return res.data;
}

async function getTimetables(lineId: number) {
  const res = await axios.get(`${REACT_APP_SICTM_URL}/timetables/?lid=${lineId}`)
  return res.data;
}

async function getAllStops(search?: string) {
  const entity = getEntity();

  try {
    const res = await axios.get(
      `${REACT_APP_SICTM_URL}/stops/${entity.name}/all?${search ? `q=${search}` : ""}`
    );
    return res.data;
  } catch (err) { }
}

async function getAllLines(all?: boolean) {
  const entity = getEntity();
  const uri = all ? 'short' : `${entity.name}/short`;

  try {
    const res = await axios.get(`${REACT_APP_SICTM_URL}/lines/${uri}`);
    if (REACT_APP_SICTM_URL === undefined) return [];
  
    return res.data.linesInfo;
  } catch (err) { }
}

async function getFareTitle(id: number) {
  const res = await axios.get(`${REACT_APP_SICTM_URL}/faretitles/${id}`);
  return res.data;
}

async function getFareTowns() {
  const entity = getEntity();
  
  const res = await axios.get(`${REACT_APP_SICTM_URL}/faretowns/${entity.name}`);
  return res.data;
}

export const SictmApi = {
  getLines,
  getLinesShort,
  getNextStops,
  getSublines,
  getNotifications,
  getNotificationById,
  getTimetables,
  getAllStops,
  getAllLines,
  getStopById,
  getLineById,
  getFareTitle,
  getFareTowns,
};
